import ClearIcon from '@mui/icons-material/Clear'
import SyncAltIcon from '@mui/icons-material/SyncAlt'
import { Badge, IconButton } from '@mui/material'

const ResetColumnOrder = ({
  columnOrder,
  onClearColumnOrder,
  defaultColumnOrder,
}: {
  columnOrder: string[]
  onClearColumnOrder: () => void
  defaultColumnOrder: string[]
}) => {
  const isVisibilityChanged = Object.keys(columnOrder).some(
    column => columnOrder[column] !== defaultColumnOrder[column]
  )
  return (
    <IconButton
      sx={{
        color: isVisibilityChanged
          ? 'text.primary' // Active columns color
          : 'text.tertiary', // Default gray color when no changes
        borderRadius: '0px',
      }}
      disabled={isVisibilityChanged ? false : true}
      onClick={onClearColumnOrder}
    >
      <Badge
        badgeContent={
          <ClearIcon
            sx={{
              fontSize: '18px',
              color: isVisibilityChanged ? 'text.error' : 'text.secondary',
            }}
          />
        }
        color="default"
      >
        <SyncAltIcon
          sx={{
            fontSize: '30px',
            color: isVisibilityChanged ? 'text.primary' : 'text.secondary', // Active filters color
          }}
        />
      </Badge>
    </IconButton>
  )
}

export default ResetColumnOrder
